import clsx from 'clsx';
import { DescriptionProps } from '../types';
import { useBrandedColors } from '../hooks/use-branded-colors';

export const Description = ({ title, text, commonTermsTitle, commonTermsUrl, secciTitle, secciUrl, brandColor }: DescriptionProps) => {
    const { useBrandedColorsBool, getStyle } = useBrandedColors({ brandColor });

    return (
        <div className="r-mx-auto r-mb-12 r-pb-6 r-pt-12 md:r-pt-20 xl:r-px-12">
            <h3 className="r-text-xl r-font-medium">{title}</h3>
            <div className="r-my-4 r-text-sm r-leading-6" dangerouslySetInnerHTML={{ __html: text }} />
            {((secciTitle && secciUrl?.url) || (commonTermsTitle && commonTermsUrl?.url)) && (
                <ul className={clsx('styled-link', useBrandedColorsBool ? 'brand-styles' : '')} style={useBrandedColorsBool ? getStyle() : {}}>
                    {commonTermsTitle && commonTermsUrl?.url && (
                        <li className="r-border-b r-border-b-[rgba(0,105,101,0.2)] r-py-2">
                            <a
                                href={commonTermsUrl.url}
                                target={commonTermsUrl?.target || '_self'}
                                className="external-link r-flex r-flex-row r-justify-between"
                            >
                                <div className="r-flex r-flex-row r-gap-2">
                                    <img src="/assets/icons/document.svg" width={20} height={20} alt="" className="" />
                                    <span>{commonTermsTitle}</span>
                                </div>
                            </a>
                        </li>
                    )}
                    {secciTitle && secciUrl?.url && (
                        <li className="r-border-b r-border-b-[rgba(0,105,101,0.2)] r-py-2">
                            <a href={secciUrl.url} target={secciUrl?.target || '_self'} className="external-link r-flex r-flex-row r-justify-between">
                                <div className="r-flex r-flex-row r-gap-2">
                                    <img src="/assets/icons/document.svg" width={20} height={20} alt="" className="" />
                                    <span>{secciTitle}</span>
                                </div>
                            </a>
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};
